import { render, staticRenderFns } from "./EditCategoryModal.vue?vue&type=template&id=5cf87c5d&scoped=true&"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryModal.vue?vue&type=style&index=0&id=5cf87c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf87c5d",
  null
  
)

export default component.exports